import { marshal, Nullable } from "@gsx/common";
import { injectable } from "inversify";
import { EditStore } from "../../general/EditStore";
import { Api } from "../../../../../common/src/api/Api";
import { QuiltyResourceBody } from "@gsx/common/src/types/http/admin/quiltyResource";
import { createQuiltyResourceEmptyBody } from "../../../../src/utility/entity/quiltyResource";

// EditStoreVuex is not used here, because components are modifying
// data properties directly. That behaviour is not supported by vuex.
// The whole data would have to be replaced instead.

@injectable()
export class QuiltyResourceEditStore extends EditStore<QuiltyResourceBody> {
    private id: string = "";
    readonly data: Nullable<QuiltyResourceBody> = createQuiltyResourceEmptyBody();
    quiltyResourceMedia: FormData = new FormData();

    constructor(private readonly api: Api) {
        super();
    }

    public setId(value: string): void {
        this.id = value;
    }

    protected async loadRequest(): Promise<QuiltyResourceBody> {
        return this.api.admin.quiltyResources.get(this.id);
    }

    protected async updateRequest(): Promise<void> {
        const body = marshal(this.data);
        await this.api.admin.quiltyResources.update(this.id, body, this.quiltyResourceMedia);
    }
}
